import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FilterChip {
  id: string | number,
  name: string,
  quantity: string | number
  active: boolean
}

@Component({
  selector: 'kion-filter-chips',
  templateUrl: './filter-chips.component.html',
  styleUrls: ['./filter-chips.component.scss']
})
export class FilterChipsComponent {

  @Input() filterChips: FilterChip[] = [];
  // tslint:disable-next-line:no-output-rename
  @Output('selected') filterSelectedEmitter: EventEmitter<FilterChip> = new EventEmitter<FilterChip>();

  chipSelected(chip: FilterChip) {
    this.filterSelectedEmitter.emit(chip);
  }
}
